import styles from './FeedbackButton.module.css';

import ThumbUpIcon from '#/assets/thumb-up.svg?react'
import ThumbDownIcon from '#/assets/thumb-down.svg?react'
import { FeedbackType } from '#/types/feedback.ts';

interface FeedbackButtonsProps {
  selectedFeedback: FeedbackType | null;
  onFeedback: (type: FeedbackType) => void;
}

export function FeedbackButtons({ selectedFeedback, onFeedback }: FeedbackButtonsProps) {
  return (
    <div className={styles.messageFeedback}>
      <div className={styles.messageFeedbackInner}>
        <button
          className={`${styles.feedbackBtn} ${selectedFeedback === FeedbackType.POSITIVE ? styles.selected : ''}`}
          onClick={() => onFeedback(FeedbackType.POSITIVE)}
        >
          <ThumbUpIcon className={styles.feedbackIcon} aria-label="thumbs up" />
        </button>
        <button
          className={`${styles.feedbackBtn} ${selectedFeedback === FeedbackType.NEGATIVE ? styles.selected : ''}`}
          onClick={() => onFeedback(FeedbackType.NEGATIVE)}
        >
          <ThumbDownIcon className={styles.feedbackIcon} aria-label="thumbs down" />
        </button>
      </div>
    </div>
  );
}